import API from 'services/api';

export const getContractCooperationTypes = () => API.get('/api/cooperation-types');
